import { useState } from 'react';

// Per-user course progress is client-side state (the licensing server does not track it)
export const getDoneSlugs = (courseSlug) => {
  try {
    return (
      JSON.parse(localStorage.getItem(`documentation-course-${courseSlug}-done`)) ||
      []
    );
  } catch (e) {
    return [];
  }
};

export const useCourseProgress = (courseSlug) => {
  const storageKey = `documentation-course-${courseSlug}-done`;

  const [doneSlugs, setDoneSlugs] = useState(() => getDoneSlugs(courseSlug));

  function markDone(entrySlug) {
    setDoneSlugs((prev) => {
      if (prev.includes(entrySlug)) return prev;
      const next = [...prev, entrySlug];
      localStorage.setItem(storageKey, JSON.stringify(next));
      return next;
    });
  }

  return {
    doneSlugs,
    markDone,
    isDone: (entrySlug) => doneSlugs.includes(entrySlug),
  };
};
